import { CSVRecord } from '../../shared/models/member-csvrecord';
import { ILoginResult } from './../../models/login-result';
import { UrlService } from './../url.service';
import {
  tap,
  takeUntil,
  map,
  catchError,
  take,
  shareReplay,
} from 'rxjs/operators';
import { IOrganization } from './../../models/organization';
import { ILoginInformation } from './../../models/login-information';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnInit, OnDestroy } from '@angular/core';

import firebase from 'firebase/compat/app';
import { Subject, Observable, BehaviorSubject, throwError, of } from 'rxjs';
import { Store } from '@ngxs/store';
import { IMember, IMemberResult } from './../../models/member';
import { debounceTime } from 'rxjs/operators';
import { IRole } from './../../models/role';
import {
  UpdatePasswordRequest,
  PasswordResult,
  UpdateEmailRequest,
} from '../../users/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService implements OnDestroy, OnInit {
  updateValidatedEmail(userId: string, newEmail: string): Observable<boolean> {
    const url = `${this.urlService.buildUrl(
      'users',
      'update-validated-email'
    )}/${userId}`;
    return this.http.post<boolean>(`${url}`, {
      externalUserId: userId,
      newEmail,
    });
  }
  currentUser$ = new BehaviorSubject<IMember>(undefined);
  currentOrganization$ = new BehaviorSubject<IOrganization>(undefined);
  organizations$ = new BehaviorSubject<Array<IOrganization>>(undefined);
  hasOrganization$ = new BehaviorSubject<boolean>(false);

  private unSubscribeAll$ = new Subject<void>();
  urlService = new UrlService();
  roles: IRole[];
  loginUser: any;
  loginInformation = new BehaviorSubject<ILoginInformation>(undefined);

  actions: string[];

  loggedIn(): boolean {
    const firebaseUser = this.getCurrentUser().then((user) => {});
    return !!firebaseUser;
  }

  setRoles(roles: IRole[]): void {
    this.roles = roles;
  }

  loggedOut(): boolean {
    const firebaseUser = this.getCurrentUser().then((user) => {});

    return !firebaseUser;
  }

  getCurrentUser() {
    return new Promise<any>((resolve, reject) => {
      // rewrite to return a boolean/
      if (
        localStorage.getItem('user') &&
        localStorage.getItem('user') === 'undefined'
      ) {
        localStorage.removeItem('user');
      }
      if (localStorage.getItem('user')) {
        resolve(JSON.parse(localStorage.getItem('user')));
      } else {
        resolve(undefined);
        // reject('No user logged in');
      }
    });
  }

  getCurrentUserName() {
    return new Promise<any>((resolve, reject) => {
      // rewrite to return a boolean/
      if (localStorage.getItem('user')) {
        let user = JSON.parse(localStorage.getItem('user'));
        resolve(user.email);
      }

      if (!firebase) {
        resolve(undefined);
        return;
      }
      if (!firebase.auth) {
        resolve(undefined);
        return;
      }

      const user = firebase.auth().onAuthStateChanged((userResponse) => {
        if (userResponse) {
          resolve(userResponse.email);
        } else {
          resolve(undefined);
          // reject('No user logged in');
        }
      });
    });
  }

  updateCurrentUser(value) {
    return new Promise<any>((resolve, reject) => {
      const user = firebase.auth().currentUser;
      user
        .updateProfile({
          displayName: value.name,
          photoURL: user.photoURL,
        })
        .then(
          (res) => {
            resolve(res);
          },
          (err) => reject(err)
        );
    });
  }

  updatePassword(value: UpdatePasswordRequest): Observable<PasswordResult> {
    const url = `${this.urlService.buildUrl('users', 'update-password')}`;

    return this.http.post<PasswordResult>(`${url}`, value);
  }

  updateUsername(value: UpdateEmailRequest): Observable<PasswordResult> {
    const url = `${this.urlService.buildUrl('users', 'update-username')}`;
    // const newOrganization = {
    //   roles: ['User'],
    //   organizationId: organization.id,
    //   status: 'Active',
    //   createdBy: user.id,
    // };
    // let body = {
    //   newEmail,
    //   password: currentPassword,
    // };
    return this.http.post<PasswordResult>(`${url}`, value);
  }

  updateMembershipExpiration(
    userId: string,
    organizationId: string,
    expiresAt: Date,
    notes?: string
  ): Observable<any> {
    const url = `${this.urlService.buildUrl(
      'users',
      'update-membership-expiration'
    )}`;
    return this.http.post<any>(`${url}`, {
      userId,
      organizationId,
      expiresAt,
      notes: notes || 'Manually updated by admin',
    });
  }

  constructor(private store: Store, private http: HttpClient) {}
  ngOnInit(): void {}

  setActions(): void {
    // this.sto
  }

  ngOnDestroy() {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  setId(item): void {
    if (item && item['_id'] && !item.id) {
      item['id'] = item['_id'];
    }
  }

  login(value): Observable<ILoginResult> {
    const url = `${this.urlService.buildUrl('users', 'login')}`;
    return this.http
      .post<ILoginResult>(`${url}`, {
        token: value.token,
      })
      .pipe(
        map((res: ILoginResult) => {
          if (res && res.user && res.user.organizations) {
            res.user.organizations.forEach((item) => {
              item['organization']['id'] = item['organization']['_id'];
              item['organizationId'] = item['organization']['id'];
            });
          }

          return res || ({} as ILoginResult);
        }),
        catchError(this.errorMgmt)
      );
  }

  /**
   * Validates the Bearer token already attached by AddHeaderInterceptor and
   * returns the currently authenticated user, or errors (403) if the token
   * is missing/invalid/expired. Used to restore session state after a page
   * refresh without needing to already know the user's email. Deliberately
   * does not use errorMgmt — callers need the raw HttpErrorResponse.status
   * to distinguish "not authenticated" (403) from a transient network/5xx
   * failure.
   */
  getSession(): Observable<IMemberResult> {
    const url = `${this.urlService.buildUrl('users', 'session')}`;
    return this.http.get<IMemberResult>(url);
  }

  private orgChangeCache = new Map<string, Observable<ILoginResult>>();
  setCurrentOrganization(organizationId: any): Observable<ILoginResult> {
    // If we’ve already made this call, return the cached observable
    if (this.orgChangeCache.has(organizationId)) {
      return this.orgChangeCache.get(organizationId)!;
    }

    const url = `${this.urlService.buildUrl(
      'users',
      'change-organization',
      organizationId
    )}`;
    const request$ = this.http.get<ILoginResult>(`${url}`).pipe(
      take(1), // Only take the first result
      shareReplay(1) // Cache the result
    );
    this.orgChangeCache.set(organizationId, request$);

    return request$;
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    return throwError(errorMessage);
  }

  private loginInfoCache = new Map<string, Observable<IMemberResult>>();

  getLoginInformation(email: string) {
    // console.log('setLoginInformation', email);

    if (this.loginInfoCache.has(email)) {
      return this.loginInfoCache.get(email)!;
    }
    const url = `${this.urlService.buildUrl(
      'users',
      'getLoginInformation'
    )}/${email}`;

    const request$ = this.http.get<IMemberResult>(`${url}`).pipe(
      takeUntil(this.unSubscribeAll$),
      debounceTime(2000),
      tap((userResponse) => {
        // console.log('userService userResponse', userResponse)
        const loginInformation: ILoginInformation = (<
          ILoginInformation
        >{}) as ILoginInformation;

        //1. Set Current Organization
        let organization = userResponse.organizations[0] as IOrganization;

        if (
          userResponse.preferences &&
          userResponse.preferences.defaultOrganization
        ) {
          organization = userResponse.organizations.find(
            (org) =>
              org.organizationId ===
              userResponse.preferences.defaultOrganization
          );
        }

        if (organization) {
          organization.id = organization.organizationId;
        }

        //2. Set Current User
        loginInformation.currentOrganization = organization;
        loginInformation.currentUser = userResponse;

        loginInformation.currentUser.id = userResponse['_id'];
        loginInformation.organizations = userResponse.organizations;
        //Place User Org Attributes on root user
        if (organization && organization.attributes) {
          loginInformation.currentUser.attributes = organization.attributes;
        }
        //return the different  current Items

        this.loginUser = loginInformation;
        this.loginInformation.next(loginInformation);
        this.currentUser$.next(loginInformation.currentUser);
        this.currentOrganization$.next(loginInformation.currentOrganization);
        this.organizations$.next(loginInformation.organizations);

        if (loginInformation.currentOrganization) {
          this.actions = this.getActions(
            loginInformation.currentOrganization.roles
          );
        }
      })
    );

    this.loginInfoCache.set(email, request$);
    return request$;
  }

  setHasOrganization(value: boolean): void {
    this.hasOrganization$.next(value);
  }

  setLoginInformation(userInformation: IMemberResult): void {
    let loginInformation: ILoginInformation = (<
      ILoginInformation
    >{}) as ILoginInformation;

    //1. Set Current Organization
    let organization = undefined;

    if (
      userInformation &&
      userInformation.organizations &&
      userInformation.organizations.length > 0
    ) {
      organization = userInformation.organizations[0] as IOrganization;
    }

    if (
      userInformation.preferences &&
      userInformation.preferences.defaultOrganization
    ) {
      const org = userInformation.organizations.find(
        (org) => org.id === userInformation.preferences.defaultOrganization
      );
      //set default organization 2024-04-28
      organization = org ? org : userInformation.organizations[0];
    }

    //2. Set Current User
    loginInformation.currentOrganization = organization;
    loginInformation.currentUser = userInformation;

    loginInformation.organizations = userInformation.organizations;

    this.loginUser = loginInformation;
    this.loginInformation.next(loginInformation);
    this.currentUser$.next(loginInformation.currentUser);
    this.currentOrganization$.next(loginInformation.currentOrganization);
    this.organizations$.next(loginInformation.organizations);

    this.actions =
      loginInformation &&
      loginInformation.currentOrganization &&
      loginInformation.currentOrganization.roles
        ? this.getActions(loginInformation.currentOrganization.roles)
        : [];
  }

  setUser(userInformation: IMemberResult): void {
    this.currentUser$.next(userInformation);
  }

  getActions(userRoles: string[]): string[] {
    const organizationRoles =
      this.store.snapshot().application &&
      this.store.snapshot().application.roles
        ? this.store.snapshot().application.roles
        : this.roles;

    if (organizationRoles === undefined || organizationRoles === null)
      return [];

    var rolesAndActions = organizationRoles.filter((currentRole) =>
      userRoles.includes(currentRole.role)
    );
    let actions = [].concat(
      ...rolesAndActions.map(({ actions, ...r }) => actions.map((o) => o))
    );
    actions = [...new Set(actions)];

    return actions;
  }

  import(
    records: CSVRecord[],
    organization: IOrganization,
    user: IMember
  ): Observable<ImportResult> {
    const url = `${this.urlService.buildUrl('users', 'import')}`;

    const newOrganization = {
      roles: ['User'],
      organizationId:
        organization.organizationId || organization.id || organization['_id'],
      status: 'Active',
      createdBy: user.id,
    };
    let body = {
      importRecords: records,
      organization: newOrganization,
    };
    return this.http.post<any>(`${url}`, body);
  }
}

export class ImportResult {
  error: any;
  existingRecords: CSVRecord[];
  errorRecords: CSVRecord[];
  successRecords: CSVRecord[];
}
